import styles from "./indication.module.scss";
import PropTypes from "prop-types";

import {
	Button,
} from "../../atoms/DependencyHelper";

export const IndicationState = {
	Bad: "bad",
	Good: "good",
	Question: "question",
	Warning: "warning",
  PreOrder: "preorder",
};

const Indication = ({
	actionLabel,
	className,
	description,
	extended,
	onActionClick,
	showAction,
	state,
	type,
	uniqueIndication,
  days,
  preOrder
}) => {
	if (!state && !description) return;

  if (preOrder) type = 'preorder';

	const handleActionClick = () => {
		typeof onActionClick === "function"
			&& onActionClick();
	}

	return (
		<div className={className}>
			<div className={`${styles.indication} ${styles["indication--" + type]}`}>
				<span
					className={`${styles["indication__state"]} ${preOrder ? styles.PreOrderIndication : ''}`}
					uniqueIndicationId={uniqueIndication}
				>
          <span>
					{preOrder ? 'Available for pre-order!' : state}
          </span>
				</span>
				{extended}

        {state === 'Out of stock' && showAction ?
          <span className={styles.notifyStock} onClick={() => handleActionClick()}>Get notified when it’s back in stock</span>
          :
          <span
            className={styles["indication__description"]}
            uniqueIndicationId={uniqueIndication}
          >
					{preOrder ? 'Select how you\'d like to pay to continue' : description}
            <span>{preOrder ? '' : days}</span>
				</span>
        }
      </div>
    </div>
  );
};

Indication.defaultProps = {
  actionLabel: "",
  optionsList: [],
  showAction: false,
  selectedValue: "",
  uniqueIndication: "",
};

Indication.propTypes = {
  actionLabel: PropTypes.string,
  onActionClick: PropTypes.func,
    showAction: PropTypes.bool,
	type: PropTypes.oneOf(["good", "bad", "question", "warning"]),
	className: PropTypes.string,
	state: PropTypes.string,
	description: PropTypes.string,
	uniqueIndication: PropTypes.string,
	extended: PropTypes.any,
};

export default Indication;
